import React from 'react';
import {brand, space, fontFamily} from './theme';

export const btnStyle: React.CSSProperties = {
  padding: `${space(1)} ${space(2)}`,
  cursor: 'pointer',
  borderRadius: '10px',
  border: `1px solid ${brand.border}`,
  background: brand.bgMuted,
  color: brand.cream,
  fontSize: '14px',
  fontFamily,
  fontWeight: 500,
  transition: 'all 0.15s ease',
};

export const btnPrimaryStyle: React.CSSProperties = {
  ...btnStyle,
  background: `linear-gradient(135deg, ${brand.red}, ${brand.accent})`,
  color: '#fff',
  border: 'none',
  fontWeight: 600,
};

export const newBtnStyle: React.CSSProperties = {
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  fontSize: '18px',
  color: brand.tealLight,
  padding: '0 4px',
  lineHeight: 1,
  fontWeight: 600,
};

export const sidebarStyle: React.CSSProperties = {
  width: '260px',
  borderRight: `1px solid ${brand.border}`,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'auto',
  background: brand.bgCard,
  flexShrink: 0,
};

export const idBadgeStyle: React.CSSProperties = {
  fontSize: '11px',
  color: brand.creamMuted,
  background: brand.bgMuted,
  padding: '2px 8px',
  borderRadius: '4px',
  cursor: 'pointer',
  fontFamily,
};
